import { createModalSlice } from 'shared/lib/factory/redux/createModalSlice'

export const migrateFreeUsersToNewBillingModalSlice = createModalSlice(
  'migrateFreeUsersToNewBillingModal',
)

export const migrateFreeUsersToNewBillingModalActions =
  migrateFreeUsersToNewBillingModalSlice.actions
